import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { connectedProvidersReport } from 'redux/selectors';

export const useFilteredProviders = () => {
  const { items } = useSelector(({ providers }) => providers);
  const providersReport = useSelector(connectedProvidersReport);

  const filteredProviders = useMemo(() => {
    return items
      .filter((item) => item.srv)
      .reduce((groups, provider) => {
        const srv = provider.srv;
        if (!groups[srv]) {
          groups[srv] = [srv];
        }
        return groups;
      }, {});
  }, [items]);

  const filteredConnectedProviders = useMemo(() => {
    return providersReport?.providers?.reduce((groups, provider) => {
      const srv = provider;
      if (!groups[srv]) {
        groups[srv] = [srv];
      }
      return groups;
    }, {});
  }, [providersReport]);

  return {
    filteredProviders,
    filteredConnectedProviders,
  };
};
